export const SDK_VERSION = '7.36.0';
